(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamDialogController', CareTeamDialogController);

    CareTeamDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'careTeam', 'CareTeam', '$state', 'CareTeamSpecialty'];

    function CareTeamDialogController ($timeout, $scope, $uibModalInstance, careTeam, CareTeam, $state, CareTeamSpecialty) {
        var vm = this;

        vm.careTeam = careTeam;
        vm.clear = clear;
        vm.save = save;
        vm.editing = $state.current.name != "care-team-view";
        vm.careteamspecialties = CareTeamSpecialty.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.careTeam.id !== null) {
                CareTeam.update(vm.careTeam, onSaveSuccess, onSaveError);
            } else {
                CareTeam.save(vm.careTeam, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:careTeamUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
